import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface UserDisplaySectionProps {
  name: string;
  email: string;
}

export function UserDisplaySection({ name, email }: UserDisplaySectionProps) {
  return (
    <div className="px-2 py-3 border-b">
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="font-semibold text-sm truncate">{name}</div>
        </TooltipTrigger>
        <TooltipContent>{name}</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="text-xs text-muted-foreground truncate">{email}</div>
        </TooltipTrigger>
        <TooltipContent>{email}</TooltipContent>
      </Tooltip>
    </div>
  );
}
